// extracted by mini-css-extract-plugin
export default {"box":"branchlist_box__xMnvA"};